import piexif from 'piexifjs'
import readImage from './readImage'
import reduceImageQuallity from './reduceImageQuality'
import writeImage from './writeImage'

const MAX_DAYS = 3;

export default (value, todayImage) => {
  return new Promise(function (resolve) {
    readImage(value)
      .then(readedImage => {
        reduceImageQuallity(readedImage)
          .then(reducedImage => {
            writeImage(reducedImage)
              .then(writedImage => {
                let error = false;
                const mdata = piexif.load(reducedImage)
                if (todayImage) {
                  error = true;

                  let creationDate = mdata && mdata.Exif ?  mdata.Exif["36867"] : null

                  if (creationDate) {
                    let today = new Date();
                    today.setHours(0, 0, 0, 0);

                    let imageDate = new Date(
                      creationDate.slice(0, 4),
                      creationDate.slice(5, 7) - 1,
                      creationDate.slice(8, 10)
                    );

                    const diffDays = (today - imageDate) / 86400000;

                    if (diffDays <= MAX_DAYS) {
                      error = false;
                    }
                  }
}
                resolve({
                  src: reducedImage,
                  file: writedImage,
                  error: error,
                  metadata: mdata ? piexif.dump(mdata) : null
                })
              })
          })
      })
  })
}



// WEBPACK FOOTER //
// ./src/utils/validateImageData.js